import { apiClient } from '@/lib/api/client'
import type {
  CreateTestNotificationDto,
  DeleteResultDto,
  NotificationResponseDto,
  UnreadCountResponseDto,
} from '@fp3/shared'

interface ScheduleTestResponse {
  scheduledAt: string
}

interface PaginatedNotifications {
  items: NotificationResponseDto[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export const notificationsApi = {
  getAll: async (params: { page: number; limit: number }): Promise<PaginatedNotifications> => {
    const { data } = await apiClient.get<PaginatedNotifications>('/notifications', { params })
    return data
  },

  getUnreadCount: async (): Promise<UnreadCountResponseDto> => {
    const { data } = await apiClient.get<UnreadCountResponseDto>('/notifications/unread-count')
    return data
  },

  markAsRead: async (id: string): Promise<void> => {
    await apiClient.patch(`/notifications/${id}/read`)
  },

  markAsUnread: async (id: string): Promise<void> => {
    await apiClient.patch(`/notifications/${id}/unread`)
  },

  markAllAsRead: async (): Promise<void> => {
    await apiClient.patch('/notifications/read-all')
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/notifications/${id}`)
  },

  removeAllRead: async (): Promise<DeleteResultDto> => {
    const { data } = await apiClient.delete<DeleteResultDto>('/notifications/read')
    return data
  },

  createTest: async (dto: CreateTestNotificationDto): Promise<ScheduleTestResponse> => {
    const { data } = await apiClient.post<ScheduleTestResponse>('/notifications/test', dto)
    return data
  },
}
